import { useEffect, useState, useCallback } from 'react';
import { listTracking, importTracking, removeTracking, getCode, setCode, clearCode } from '../api/lionjob';
import LionjobPager from '../components/LionjobPager';

// MÃ VẬN ĐƠN — dán danh sách từ Excel/CSV vào đây, extension 🚚 sẽ khớp với đơn
// đang hiển thị trên Etsy/Amazon và điền hộ. Nút xác nhận của sàn vẫn do người bấm.
const ST = { pending: 'Chờ điền', filled: 'Đã điền', skipped: 'Bỏ qua' };
const ST_CLS = { pending: 'warn', filled: 'ok', skipped: 'mute' };

export default function TrackingPage() {
  const [unlocked, setUnlocked] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [lockErr, setLockErr] = useState('');
  const [unlocking, setUnlocking] = useState(false);

  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({ page: 1, totalPages: 1, total: 0 });
  const [stat, setStat] = useState({});
  const [page, setPage] = useState(1);
  const [platform, setPlatform] = useState('etsy');
  const [status, setStatus] = useState('pending');
  const [q, setQ] = useState('');
  const [msg, setMsg] = useState('');
  const [paste, setPaste] = useState('');
  const [shop, setShop] = useState('');
  const [busy, setBusy] = useState(false);
  const [showImport, setShowImport] = useState(false);

  const load = useCallback(async () => {
    try {
      const d = await listTracking({ page, limit: 50, platform, status, q: q || undefined });
      setRows(d.rows); setStat(d.stat || {});
      setMeta({ page: d.page, totalPages: d.totalPages, total: d.total });
      setUnlocked(true);
    } catch (e) {
      const m = e.response?.data?.message || e.message || 'Không kết nối được backend';
      if (e.response?.status === 403) { clearCode(); setUnlocked(false); }
      setLockErr(m); setMsg('Lỗi: ' + m);
    }
  }, [page, platform, status, q]);

  useEffect(() => { if (unlocked) load(); }, [load, unlocked]);
  useEffect(() => { if (getCode()) load(); /* eslint-disable-next-line */ }, []);

  async function unlock(e) {
    e?.preventDefault();
    const c = codeInput.trim(); if (!c) { setLockErr('Nhập mã code'); return; }
    setLockErr(''); setCode(c); setUnlocking(true);
    try { await load(); } finally { setUnlocking(false); }
  }

  async function doImport() {
    if (!paste.trim()) { setMsg('Chưa dán dữ liệu'); return; }
    setBusy(true);
    try {
      const r = await importTracking({ text: paste, platform, shop });
      setMsg('✓ ' + r.message + (r.bad?.length ? ` — bỏ: ${r.bad.slice(0, 3).join(' | ')}` : ''));
      setPaste(''); setShowImport(false); load();
    } catch (e) { setMsg('Lỗi nhập: ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(false); }
  }
  async function del(r) {
    if (!window.confirm(`Xoá mã vận đơn của đơn ${r.orderId}?`)) return;
    try { await removeTracking(r.id); setMsg('✓ Đã xoá'); load(); }
    catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
  }

  if (!unlocked) {
    return (
      <div className="tk-root"><style>{CSS}</style>
        <div className="tk-lock"><div className="tk-lockCard">
          <div className="tk-lockIco">🦁</div><h2>Mã vận đơn</h2>
          <p className="tk-lockSub">Khu vực chỉ dành cho Giám đốc. Nhập mã code để mở.</p>
          <form onSubmit={unlock}>
            <input className="tk-lockInput" type="password" autoFocus placeholder="Mã code" disabled={unlocking}
              value={codeInput} onChange={(e) => setCodeInput(e.target.value)} />
            <button className="tk-btn primary" type="submit" disabled={unlocking} style={{ width: '100%', marginTop: 10 }}>
              {unlocking ? '⏳ Đang kết nối…' : 'Mở khóa'}</button>
          </form>
          {lockErr && <div className="tk-lockErr">⚠ {lockErr}</div>}
        </div></div>
      </div>
    );
  }

  const s = stat[platform] || {};

  return (
    <div className="tk-root"><style>{CSS}</style>
      <div className="tk-head">
        <div>
          <h2>Mã vận đơn</h2>
          <div className="tk-sub">{msg || 'Dán danh sách từ Excel, rồi mở trang đơn hàng trên sàn và dùng extension 🚚 để điền hộ.'}</div>
        </div>
        <div className="tk-sp" />
        <button className="tk-btn primary" onClick={() => setShowImport((v) => !v)}>
          {showImport ? '× Đóng' : '＋ Nhập danh sách'}</button>
      </div>

      <div className="tk-strip">
        <Tile k="Chờ điền" v={s.pending || 0} flag={(s.pending || 0) > 0} />
        <Tile k="Đã điền" v={s.filled || 0} />
        <Tile k="Bỏ qua" v={s.skipped || 0} />
        <Tile k="Đang xem" v={meta.total} n={`${platform} · ${ST[status] || 'tất cả'}`} />
      </div>

      {showImport && (
        <div className="tk-import">
          <h3>Dán danh sách</h3>
          <p className="tk-hint">Mỗi dòng: <b>mã đơn</b> — <b>mã vận đơn</b> — <b>hãng vận chuyển</b> (không bắt buộc).
            Ngăn cách bằng tab (dán thẳng từ Excel), phẩy, chấm phẩy hoặc khoảng trắng.
            Dòng tiêu đề và ghi chú sẽ tự bị bỏ qua.</p>
          <textarea className="tk-ta" rows={8} value={paste} onChange={(e) => setPaste(e.target.value)}
            placeholder={'3456789012\t9400111899223197428130\tUSPS\n3456789013,9400111899223197428131,DHL'} />
          <div className="tk-row" style={{ marginTop: 10 }}>
            <select className="tk-fld" value={platform} onChange={(e) => setPlatform(e.target.value)}>
              <option value="etsy">Etsy</option><option value="amazon">Amazon</option><option value="other">Khác</option>
            </select>
            <input className="tk-fld" placeholder="Tên shop (không bắt buộc)" value={shop} onChange={(e) => setShop(e.target.value)} />
            <button className="tk-btn primary" onClick={doImport} disabled={busy}>{busy ? '⏳ Đang nhập…' : 'Nhập'}</button>
          </div>
        </div>
      )}

      <div className="tk-filters">
        <div className="tk-row">
          <span className="tk-lab">Sàn</span>
          {[['etsy', 'Etsy'], ['amazon', 'Amazon'], ['other', 'Khác'], ['all', 'Tất cả']].map(([v, l]) => (
            <button key={v} className={'tk-pill' + (platform === v ? ' on' : '')}
              onClick={() => { setPlatform(v); setPage(1); }}>{l}</button>
          ))}
          <span className="tk-lab" style={{ marginLeft: 8 }}>Trạng thái</span>
          {[['pending', 'Chờ điền'], ['filled', 'Đã điền'], ['skipped', 'Bỏ qua'], ['all', 'Tất cả']].map(([v, l]) => (
            <button key={v} className={'tk-pill' + (status === v ? ' on' : '')}
              onClick={() => { setStatus(v); setPage(1); }}>{l}</button>
          ))}
          <input className="tk-fld" style={{ marginLeft: 'auto', minWidth: 180 }} placeholder="Tìm mã đơn / mã vận đơn…"
            value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} />
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="tk-empty">
          <div style={{ fontSize: 34, marginBottom: 8 }}>🚚</div>
          <b>Chưa có mã vận đơn nào</b>
          <p>Bấm <b>＋ Nhập danh sách</b> rồi dán từ Excel. Sau đó mở trang đơn hàng trên Etsy/Amazon,
            bấm icon 🦁 → <b>“🚚 Điền mã vận đơn”</b>.</p>
        </div>
      ) : (
        <div className="tk-tblwrap">
          <table className="tk-tbl">
            <thead><tr><th>Mã đơn</th><th>Mã vận đơn</th><th>Hãng</th><th>Sàn</th><th>Trạng thái</th><th>Điền lúc</th><th /></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td className="mono">{r.orderId}</td>
                  <td className="mono">{r.tracking}</td>
                  <td>{r.carrier || '—'}</td>
                  <td>{r.platform}</td>
                  <td><span className={'tk-chip ' + (ST_CLS[r.status] || 'mute')}>{ST[r.status] || r.status}</span></td>
                  <td className="mono dim">{r.filledAt ? new Date(r.filledAt).toLocaleString('vi') : '—'}</td>
                  <td><button className="tk-del" onClick={() => del(r)} title="Xoá">×</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <LionjobPager page={meta.page} totalPages={meta.totalPages} onGo={setPage} />
    </div>
  );
}

function Tile({ k, v, n, flag }) {
  return <div className={'tk-tile' + (flag ? ' flag' : '')}>
    <div className="tk-tk">{k}</div><div className="tk-tv">{v}</div>{n && <div className="tk-tn">{n}</div>}</div>;
}

const CSS = `
.tk-root{color:var(--text);padding-bottom:30px}
.tk-head{display:flex;gap:10px;align-items:flex-start;margin-bottom:14px;flex-wrap:wrap}
.tk-head h2{margin:0;font-size:20px}
.tk-sub{color:var(--muted);font-size:12.5px;margin-top:3px;max-width:74ch}
.tk-sp{flex:1}
.tk-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:7px 13px;border-radius:9px;cursor:pointer;font-size:13px}
.tk-btn:hover:not(:disabled){border-color:var(--accent)}
.tk-btn:disabled{opacity:.45;cursor:not-allowed}
.tk-btn.primary{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}

.tk-strip{display:grid;grid-template-columns:repeat(auto-fit,minmax(130px,1fr));gap:10px;margin-bottom:14px}
.tk-tile{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:11px 13px}
.tk-tk{font-size:10px;letter-spacing:.09em;text-transform:uppercase;color:var(--muted);font-weight:600}
.tk-tv{font-size:21px;font-weight:600;margin-top:3px;font-family:var(--font-mono)}
.tk-tn{font-size:11px;color:var(--muted);margin-top:1px}
.tk-tile.flag{border-color:var(--warn)}.tk-tile.flag .tk-tv,.tk-tile.flag .tk-tk{color:var(--warn)}

.tk-import{background:var(--panel);border:1px solid var(--accent);border-radius:var(--radius);padding:14px 16px;margin-bottom:14px}
.tk-import h3{margin:0 0 6px;font-size:13px;letter-spacing:.06em;text-transform:uppercase;color:var(--muted)}
.tk-hint{color:var(--muted);font-size:12px;margin:0 0 10px;line-height:1.6}
.tk-hint b{color:var(--text)}
.tk-ta{width:100%;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:10px;padding:10px 12px;font-family:var(--font-mono);font-size:12px;resize:vertical}

.tk-filters{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:11px 14px;margin-bottom:14px}
.tk-row{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.tk-lab{font-size:10px;letter-spacing:.09em;text-transform:uppercase;color:var(--muted);font-weight:600}
.tk-pill{border:1px solid var(--border);background:var(--panel);color:var(--muted);font:inherit;font-size:12px;padding:5px 11px;border-radius:20px;cursor:pointer}
.tk-pill:hover{border-color:var(--accent);color:var(--text)}
.tk-pill.on{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}
.tk-fld{border:1px solid var(--border);background:var(--input);color:var(--text);font:inherit;font-size:12px;padding:7px 10px;border-radius:8px}

.tk-empty{border:1px dashed var(--border);border-radius:var(--radius);padding:48px 24px;text-align:center;color:var(--muted)}
.tk-empty b{color:var(--text);display:block;margin-bottom:6px}
.tk-empty p{font-size:13px;margin:0 auto;max-width:54ch;line-height:1.7}

.tk-tblwrap{border:1px solid var(--border);border-radius:var(--radius);overflow-x:auto;background:var(--panel)}
.tk-tbl{width:100%;border-collapse:collapse;font-size:12.5px}
.tk-tbl th{text-align:left;color:var(--muted);font-size:10px;letter-spacing:.07em;text-transform:uppercase;padding:9px 12px;border-bottom:1px solid var(--border);white-space:nowrap}
.tk-tbl td{padding:8px 12px;border-bottom:1px solid var(--line)}
.tk-tbl tr:last-child td{border-bottom:0}
.tk-tbl .mono{font-family:var(--font-mono)}
.tk-tbl .dim{color:var(--muted);font-size:11px}
.tk-chip{font-size:10.5px;font-weight:600;border-radius:5px;padding:2px 7px;border:1px solid var(--border);color:var(--muted)}
.tk-chip.ok{color:var(--ok);border-color:var(--ok)}
.tk-chip.warn{color:var(--warn);border-color:var(--warn)}
.tk-del{border:0;background:none;color:var(--muted);cursor:pointer;font-size:16px;line-height:1;padding:2px 6px}
.tk-del:hover{color:var(--danger)}

.tk-lock{display:flex;justify-content:center;padding:60px 20px}
.tk-lockCard{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:28px 26px;width:340px;text-align:center}
.tk-lockIco{font-size:38px;line-height:1}.tk-lockCard h2{margin:8px 0 4px}
.tk-lockSub{color:var(--muted);font-size:13px;margin:0 0 16px}
.tk-lockInput{width:100%;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:10px;padding:10px 12px;font-size:14px;text-align:center;letter-spacing:2px}
.tk-lockErr{color:var(--danger);font-size:12px;margin-top:10px}
`;
